<template>
    <KBreadcrumbs
        :items="items"
        :link-as="NuxtLink"
    />
</template>

<script setup lang="ts">
import { KBreadcrumbs } from '@vemedia/karibu'

interface StoryblokBreadcrumb {
    name: string
    full_slug: string
}

const { parents, current, baseUrl } = defineProps<{
    parents: StoryblokBreadcrumb[]
    current: StoryblokBreadcrumb
    baseUrl: string
}>()

const NuxtLink = resolveComponent('NuxtLink')
const stories = computed(() => [...parents, current])
const path = (slug: string) => `/${slug}`.replace(/\/$/, '') || '/'
const absoluteUrl = (slug: string) => `${baseUrl.replace(/\/$/, '')}${path(slug)}`

const items = computed(() => stories.value.map((story, index) => ({
    label: story.name,
    href: index < stories.value.length - 1 ? path(story.full_slug) : undefined,
})))

const structuredData = computed(() => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': stories.value.map((story, index) => ({
        '@type': 'ListItem',
        'position': index + 1,
        'item': {
            '@id': absoluteUrl(story.full_slug),
            'name': story.name,
        },
    })),
}))

useHead({
    script: [{
        key: 'breadcrumbs-json-ld',
        type: 'application/ld+json',
        textContent: () => JSON.stringify(structuredData.value),
    }],
})
</script>
